'use client';

import { Link } from '@/i18n/navigation';
import { AlertCircle } from 'lucide-react';

export default function NotFoundClient() {
  return (
    <main className="min-h-screen bg-gray-900 flex items-center justify-center p-4">
      <div className="relative max-w-md w-full">
        {/* Glass card con glow effect */}
        <div className="absolute inset-0 bg-white/5 backdrop-blur-xl rounded-2xl border border-gray-700/50" />
        <div className="absolute inset-[1px] rounded-2xl bg-gradient-to-b from-white/10 to-transparent" />
        <div className="absolute -inset-1 bg-gradient-to-r from-purple-500/20 via-pink-500/10 to-purple-500/20 blur-xl opacity-50" />

        <div className="relative p-4 sm:p-6 lg:p-8 text-center">
          {/* Ícono con gradiente */}
          <AlertCircle className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-6 text-pink-500" />

          {/* Código 404 */}
          <div className="text-6xl font-bold text-white mb-4">404</div>

          {/* Título y descripción */}
          <h1 className="text-2xl font-bold text-white mb-3">Page Not Found</h1>
          <p className="text-gray-400 mb-8">
            The page you&apos;re looking for doesn&apos;t exist or has been moved.
          </p>

          {/* CTA */}
          <Link
            href="/"
            className="inline-block px-6 py-3 bg-gradient-to-r from-pink-600 to-purple-600 hover:from-pink-500 hover:to-purple-500 text-white font-medium rounded-lg transition-all duration-200 shadow-lg shadow-pink-500/25"
          >
            Go Home
          </Link>
        </div>
      </div>
    </main>
  );
}
